import moment from "moment";

export const Types = {
  ADD_EXTRATO: "filtrosLancamentos/ADD_EXTRATO",
  SET_FILTRO: "filtrosLancamentos/SET_FILTRO"
};

const INITIAL_STATE = {
  lojas: [],
  paid_methods: [],
  bank_accounts: [],
  payment_categories: [],
  receipt_categories: [],
  types: [],
  status: [],
  rateio: null,
  date_type: "1-Data Vencimento",
  initial_date: new Date(new Date().getFullYear(), new Date().getMonth()),
  finish_date: moment()
    .add("months", 1)
    .date(0),
  openFiltro: true,
  include: []
};

export default function filtrosLancamentos(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.ADD_EXTRATO:
      return {
        ...state,
        lojas: action.payload.data.lojas,
        paid_methods: action.payload.data.paid_methods,
        bank_accounts: action.payload.data.bank_accounts,
        payment_categories: action.payload.data.payment_categories,
        receipt_categories: action.payload.data.receipt_categories,
        types: action.payload.data.types,
        status: action.payload.data.status,
        date_type: action.payload.data.date_type,
        initial_date: action.payload.data.initial_date,
        finish_date: action.payload.data.finish_date,
        include: action.payload.data.include
      };
    case Types.SET_FILTRO:
      return { ...state, openFiltro: action.payload.data };
    case Types.CLOSE:
      return { ...state, open: false };
    default:
      return state;
  }
}

export const Creators = {
  addLancamentosFiltro: data => ({
    type: Types.ADD_EXTRATO,
    payload: { data }
  }),
  setFiltro: data => ({
    type: Types.SET_FILTRO,
    payload: { data }
  })
};



// WEBPACK FOOTER //
// ./src/store/ducks/filtrosLancamentos.js